import { render, staticRenderFns } from "./BookingShifts.vue?vue&type=template&id=308cdfe0&"
import script from "./BookingShifts.vue?vue&type=script&lang=js&"
export * from "./BookingShifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports